import { render, staticRenderFns } from "./accountAdvertising.vue?vue&type=template&id=16e5df40&scoped=true"
import script from "./accountAdvertising.vue?vue&type=script&lang=js"
export * from "./accountAdvertising.vue?vue&type=script&lang=js"
import style0 from "./accountAdvertising.vue?vue&type=style&index=0&id=16e5df40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5df40",
  null
  
)

export default component.exports